/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Fade,
    Chip,
    Tabs,
    Tab,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,        
    InputAdornment,     
    FormControl,         
    InputLabel,         
    Select,             
    MenuItem as SelectMenuItem  
} from '@mui/material';
import {
    LocationCity,
    Add,
    NavigateNext,
    NavigateBefore,
    List as ListIcon,
    Edit as EditIcon,
    Block as BlockIcon,
    CheckCircle as ActivateIcon,
    Search as SearchIcon,   
    Clear as ClearIcon  
} from '@mui/icons-material';
import { useDistrict } from 'hooks/api/terminology/district/useDistrict';
import { useProvince } from 'hooks/api/terminology/province/useProvince';
import { PaginationButton, StyledTableContainer, globalColor } from '../../ConstantColors';
import { logger } from 'utils/environment/log';
import Swal from 'sweetalert2';
import AddEditDistrict from './add';
import {
    ClampedText,
    CodeText,
    ConfigurationActionMenu,
    ConfigurationPagination,
    ConfigurationStatusChip,
    formatConfigurationDate,
    stickyActionCellSx,
    stickyActionHeadSx,
    tableSx
} from '../components/ConfigurationTable';

const SearchSection = ({ searchTerm, setSearchTerm, searchField, setSearchField, onClearSearch, loading }) => {
    const searchFields = [
        { value: 'name', label: 'District Name' },
        { value: 'id', label: 'District ID' },
        { value: 'code', label: 'District Code' },
        { value: 'province.name', label: 'Province' },
        { value: 'localName', label: 'Local Name' },
        { value: 'createdBy', label: 'Created By' },
        { value: 'lastModifiedBy', label: 'Modified By' }
    ];

    return (
        <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Search Field</InputLabel>
                <Select value={searchField} label="Search Field" onChange={(e) => setSearchField(e.target.value)} disabled={loading}>
                    {searchFields.map((field) => (
                        <SelectMenuItem key={field.value} value={field.value}>
                            {field.label}
                        </SelectMenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                size="small"
                placeholder={`Search by ${searchFields.find((f) => f.value === searchField)?.label || 'District Name'}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={loading}
                sx={{ flexGrow: 1, maxWidth: 400 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={onClearSearch} disabled={loading}>
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

const DistrictList = () => {
    const [activeTab, setActiveTab] = useState(0);
    
    // States for pagination and data
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(5);

    // Search states
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('name');

    // Hooks
    const { listDistrict, updateDistrict, districts } = useDistrict();
    const { listProvince, provinces } = useProvince();

    // Additional states
    const [editingDistrict, setEditingDistrict] = useState(null);
    const [toggleConfirmOpen, setToggleConfirmOpen] = useState(false);
    const [districtToToggle, setDistrictToToggle] = useState(null);
    const [loading, setLoading] = useState(true);

    // Initial data fetch
    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            await Promise.all([listDistrict(0, 100), listProvince(0, 100)]);
        } catch (error) {
            logger.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Helper function to get nested object value
    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((current, key) => {
            return current && current[key] !== undefined ? current[key] : null;
        }, obj);
    };

    // Filter districts based on search
    const getFilteredDistricts = () => {
        if (!searchTerm.trim()) {
            return districts;
        }

        const searchLower = searchTerm.toLowerCase().trim();
        return districts.filter((district) => {
            const fieldValue = getNestedValue(district, searchField);
            if (fieldValue === null || fieldValue === undefined) {
                return false;
            }
            return String(fieldValue).toLowerCase().includes(searchLower);
        });
    };

    const filteredDistricts = getFilteredDistricts();

    const handleClearSearch = () => {
        setSearchTerm('');
        setPage(0);
    };

    const handleEditClick = (district) => {
        setEditingDistrict(district);
        setActiveTab(1);
    };

    const handleAddNew = () => {
        setEditingDistrict(null);
        setActiveTab(1);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            setEditingDistrict(null);
        }
    };

    const handleToggleActive = async (district) => {
        setDistrictToToggle(district);
        setToggleConfirmOpen(true);
    };

    const handleToggleConfirm = async () => {
        try {
            const updatedDistrict = { ...districtToToggle, isActive: !districtToToggle.isActive };
            await updateDistrict(districtToToggle.id, updatedDistrict);
            await fetchInitialData();
            setToggleConfirmOpen(false);
            setDistrictToToggle(null);
            Swal.fire({
                icon: 'success',
                title: districtToToggle.isActive ? 'District Deactivated' : 'District Activated',
                text: `The district has been successfully ${districtToToggle.isActive ? 'deactivated' : 'activated'}.`,
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            logger.error('Error toggling district status:', error);
            
            let errorMessage = 'Failed to update district status. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        }
    };

    const handleToggleCancel = () => {
        setToggleConfirmOpen(false);
        setDistrictToToggle(null);
    };

    const handleDistrictSubmitted = () => {
        fetchInitialData();
        setActiveTab(0);
        setEditingDistrict(null);
    };

    const renderDistrictsList = () => (
        <Box sx={{ mt: 4 }}>
            <SearchSection
                searchTerm={searchTerm}
                setSearchTerm={(value) => {
                    setSearchTerm(value);
                    setPage(0);
                }}
                searchField={searchField}
                setSearchField={setSearchField}
                onClearSearch={handleClearSearch}
                loading={loading}
            />

            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    {searchTerm ? (
                        <>
                            Showing {filteredDistricts.length} of {districts.length} districts
                            {filteredDistricts.length > 0 && ` matching "${searchTerm}"`}
                        </>
                    ) : (
                        <>Total: {districts.length} districts</>
                    )}
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={handleAddNew}
                    sx={{
                        backgroundColor: globalColor,
                        '&:hover': {
                            backgroundColor: globalColor,
                            opacity: 0.9
                        }
                    }}
                >
                    Add New District
                </Button>
            </Box>

            <Fade in timeout={1000}>
                <StyledTableContainer component={Paper}>
                    <Table size="small" sx={tableSx(980)}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: 108 }}>ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell sx={{ width: 100 }}>Code</TableCell>
                                <TableCell sx={{ width: 156 }}>Province</TableCell>
                                <TableCell sx={{ width: 140 }}>Local Name</TableCell>
                                <TableCell sx={{ width: 118 }}>Created</TableCell>
                                <TableCell sx={{ width: 92 }}>Status</TableCell>
                                <TableCell align="center" sx={stickyActionHeadSx}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredDistricts.length > 0 ? (
                                filteredDistricts.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((district) => (
                                    <TableRow key={district.id}>
                                        <TableCell><CodeText>{district.id}</CodeText></TableCell>
                                        <TableCell>{district.name}</TableCell>
                                        <TableCell><CodeText>{district.code}</CodeText></TableCell>
                                        <TableCell><ClampedText maxWidth={156}>{district.province?.name}</ClampedText></TableCell>
                                        <TableCell><ClampedText maxWidth={140}>{district.localName}</ClampedText></TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatConfigurationDate(district.createdAt)}</TableCell>
                                        <TableCell>
                                            <ConfigurationStatusChip active={district.isActive} />
                                        </TableCell>
                                        <TableCell align="center" sx={stickyActionCellSx}>
                                            <ConfigurationActionMenu
                                                label={district.name}
                                                actions={[
                                                    { label: 'Edit', icon: EditIcon, onClick: () => handleEditClick(district) },
                                                    {
                                                        label: district.isActive ? 'Deactivate' : 'Activate',
                                                        icon: district.isActive ? BlockIcon : ActivateIcon,
                                                        color: district.isActive ? '#b54708' : '#25643b',
                                                        onClick: () => handleToggleActive(district)
                                                    }
                                                ]}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        <Box sx={{ py: 4 }}>
                                            <Typography variant="body1" color="text.secondary">
                                                {searchTerm ? (
                                                    <>
                                                        No districts found matching "{searchTerm}" in {searchField}
                                                        <Box sx={{ mt: 2 }}>
                                                            <Typography
                                                                variant="body2"
                                                                color="primary"
                                                                sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                onClick={handleClearSearch}
                                                            >
                                                                Clear search to view all districts
                                                            </Typography>
                                                        </Box>
                                                    </>
                                                ) : (
                                                    'No districts available'
                                                )}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <ConfigurationPagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        total={filteredDistricts.length}
                        onPageChange={setPage}
                    />
                </StyledTableContainer>
            </Fade>
        </Box>
    );

    const renderToggleDialog = () => (
        <Dialog open={toggleConfirmOpen} onClose={handleToggleCancel}>
            <DialogTitle>
                {districtToToggle?.isActive ? 'Deactivate District' : 'Activate District'}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to {districtToToggle?.isActive ? 'deactivate' : 'activate'} the district "{districtToToggle?.name}"?
                    {districtToToggle?.isActive && ' This will make the district unavailable for use.'}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleToggleCancel}>Cancel</Button>
                <Button 
                    onClick={handleToggleConfirm} 
                    color={districtToToggle?.isActive ? 'warning' : 'success'} 
                    variant="contained"
                >
                    {districtToToggle?.isActive ? 'Deactivate' : 'Activate'}
                </Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '1rem',
                            textTransform: 'none'
                        }
                    }}
                >
                    <Tab icon={<ListIcon />} iconPosition="start" label="Districts List" />
                    <Tab icon={<Add />} iconPosition="start" label={editingDistrict ? 'Edit District' : 'Add New District'} />
                </Tabs>
            </Box>

            {activeTab === 0 ? (
                renderDistrictsList()
            ) : (
                <AddEditDistrict
                    editingDistrict={editingDistrict}
                    onDistrictSubmitted={handleDistrictSubmitted}
                    provinces={provinces}
                />
            )}
            
            {renderToggleDialog()}
        </Box>
    );
};

export default DistrictList;
